import type { ReactNode } from "react";

import { ROUTES } from "@/routes";

export type FaqEntry = {
  question: string;
  answer: string;
  renderAnswer?: () => ReactNode;
  excludeFromJsonLd?: boolean;
};

export const entries: ReadonlyArray<FaqEntry> = [
  {
    question: "How do I get started?",
    answer:
      "Sign up for a free account, then start generating designs immediately. Invite your team and they can collab with you in minutes.",
  },
  {
    question: "How much does it cost?",
    answer:
      "It's free to start. See our full pricing plans at flowstep.ai/pricing for details.",
    renderAnswer: () => (
      <>
        It's free to start. See our{" "}
        <a href={ROUTES.pricing} className="underline">
          full pricing plans
        </a>{" "}
        for details.
      </>
    ),
  },
  {
    question: "Do I need designs skills to use Flowstep?",
    answer:
      "Not at all. Just describe what you want and let Flowstep handle the design work for you.",
  },
  {
    question: "Does Flowstep use my data to train AI models?",
    answer:
      "No, we don't use your personal data to train AI models, and we don't allow our LLM providers to do so. We may use aggregated and anonymized feedback to improve our outputs. If our approach changes in the future, we'll update our Privacy Policy and let you know. To learn more, please check out our Privacy Policy or contact Support using the link at the bottom of the page.",
  },
  {
    question: "How does Flowstep handle data privacy and security?",
    answer:
      "We take data privacy and security seriously. We use all security measures to protect your data. To learn more, please check out our Privacy Policy or contact Support using the link at the bottom of the page.",
  },
  {
    question: "Who is behind Flowstep?",
    answer:
      "Check our About page at flowstep.ai/about to meet the team and see what we're up to.",
    renderAnswer: () => (
      <>
        Check our{" "}
        <a href={ROUTES.about} className="underline">
          About page
        </a>{" "}
        to meet the team and see what we're up to.
      </>
    ),
  },
];

export const faqJsonLdEntries: ReadonlyArray<{
  question: string;
  answer: string;
}> = entries
  .filter((entry) => !entry.excludeFromJsonLd)
  .map(({ question, answer }) => ({ question, answer }));
